module.exports = __webpack_public_path__ + "img/upload-folder.759fdd74.svg";